import React from 'react';
import { createRoot } from 'react-dom/client';
import intl from 'react-intl-universal';
import { CssBaseline, ThemeProvider } from '@mui/material';
import fuseTheme from '@proofpoint/fuse/theme';
import currentLocale from 'utils/current_locale';
import en from 'i18n/en-US';
import es from 'i18n/es-ES';
import zh from 'i18n/zh-CN';

const locales = { 'en-US': en, 'es-ES': es, 'zh-CN': zh };

const PreLoginAppLoader = (app) => {
  document.addEventListener('DOMContentLoaded', () => {
    intl.init({ currentLocale, locales }).then(() => {
      createRoot(document.getElementById('content')).render(
        <ThemeProvider theme={fuseTheme}>
          <CssBaseline />
          {app}
        </ThemeProvider>
      );
    }).catch((error) => console.error('Pre-login i18n initialization failed.', error));
  });
};

export default PreLoginAppLoader;
